import { find } from 'lodash';

import { fetchGetters } from '@/store/extensions/fetch';
import { createGetters } from '@/store/extensions/create';
import { updateGetters } from '@/store/extensions/update';
import { deleteGetters } from '@/store/extensions/delete';

export default {
  ...fetchGetters,
  ...createGetters,
  ...updateGetters,
  ...deleteGetters,

  currentUser: (state, getters) => getters.query().with('profile').with('company').first(state.currentUser),
  authenticating: state => state.authenticating,
  validating: state => state.validating,
  registering: state => state.registering,
  loggingOutCurrentUser: state => state.loggingOutCurrentUser,
  processing: state => state.processing,
  context: state => state.context,
  formModalOpened: state => state.formModalOpened,
  formModalContext: state => state.formModalContext,
  userFromContext: (state, getters) => (
    state.context ? getters.query().with('profile').first(state.context) : null
  ),
  authenticated: (state, getters) => getters.currentUser && getters.currentUser.id,
  isSubscribed: (state, getters, rootState, rootGetters) => (appName) => {
    const userMemberships = rootGetters['entities/userMemberships/query']()
      .with('app', query => query.where('machine_name', appName))
      .get();

    return userMemberships && userMemberships.length === 1;
  },
  canAccess: (state, getters) => (roleMachineName) => {
    const currentUser = getters.query().with('userMemberships').first(state.currentUser);
    if (currentUser) {
      if (currentUser.admin) {
        return true;
      }

      return find(currentUser.userMemberships, o => o.role_machine_name === roleMachineName);
    }
    return false;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/user/getters.js